import { uniqueId } from 'lodash';
import myDataIcon from '../../images/links/foundation/icn_my_data.svg';
import myTeamIcon from '../../images/links/foundation/icn_myteam.svg';
const module = 'Foundation';

export default [
  {
    id: uniqueId(),
    module,
    i18nKey: 'SH_MyData',
    icon: myDataIcon,
    url: '/foundation/mydata',
    messageApi: null,
    sort: 11,
    onlySupervisor: false,
  },
  {
    id: uniqueId(),
    module,
    i18nKey: 'SH_MyTeam',
    icon: myTeamIcon,
    url: '/foundation/myteams',
    messageApi: null,
    sort: 12,
    onlySupervisor: true,
  },
];



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/screens/Tube/screens/Index/config/links/foundation.js
 **/